export function header() {
  const el = document.querySelector('#header');
  if (el !== null && el !== undefined) {
    var lastScrollTop = 0;
    document.addEventListener(
      'scroll',
      () => {
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
          // downscroll code
          el.classList.add('hidden');
          el.classList.add('scroll');
        } else {
          el.classList.remove('scroll');
          // upscroll code
        }

        if (st == 0) {
          el.classList.remove('hidden');
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
      },
      false
    );

    const closeBtnEl = document.querySelector('.close-menu');
    const showBtnEl = document.querySelector('.menu-show');
    const navBarEl = document.querySelector('.menu');
    const showNavBar = () => {
      navBarEl.classList.add('_visible');
      document.body.style.cssText = 'overflow:hidden;';
    };
    const hideNavBar = () => {
      navBarEl.classList.remove('_visible');
      document.body.style.cssText = '';
    };
    showBtnEl.addEventListener('click', showNavBar);
    closeBtnEl.addEventListener('click', hideNavBar);
  }
}
